export const loadFromLocalStorage = name => {
  try {
    const serializedState = localStorage.getItem(name);

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch {
    return undefined;
  }
};

export const saveToLocalStorage = (name, obj) => {
  try {
    const serializedState = JSON.stringify(obj);
    localStorage.setItem(name, serializedState);
  } catch {
    // Ignore write errors.
  }
};

export const removeFromLocalStorage = name => {
  try {
    localStorage.removeItem(name);
  } catch {
    // Ignore write errors.
  }
};
